import { createContext } from 'react';
import { ProjectAccessLevel } from '../types/graphqlTypes';

/**
 * What the current viewer may do in the open project: guests per project, members and admins
 * EDIT, share-link visitors VIEW. RendererReadOnlyContext is the boolean projection of this
 * (EDIT or not); this one is for the finer distinction, e.g. whether commenting is allowed.
 */
export const ProjectAccessLevelContext = createContext<ProjectAccessLevel>(ProjectAccessLevel.View);
